import { sumBy } from "lodash-es";
import React, { MouseEvent } from "react";

import { scrollToElement } from "@utils/scroll";
import { NumberOfHitsState } from "@utils/search/@types/searchState";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { NumberOfHitsConfigurationEntry } from "@components/Search/SearchResults/StateComponents/NumberOfHits/numberOfHits.container";

type NumberOfHitsComponentProps = {
    configuration: Array<NumberOfHitsConfigurationEntry>;
    numberOfHitsComponentsState: Array<NumberOfHitsState | undefined>;
};

const NUMBER_OF_HITS_TARGET_ID_DATA_ATTR = "number_of_hits_target_id";

const NumberOfHitsComponent = ({
    configuration,
    numberOfHitsComponentsState,
}: NumberOfHitsComponentProps) => {
    const { t } = useGranite();

    const totalNumberOfHits = sumBy(
        numberOfHitsComponentsState,
        numberOfHitsComponentState =>
            numberOfHitsComponentState?.numberOfHits ?? 0,
    );

    if (!totalNumberOfHits) return null;

    const toNumberOfHitsEntry = (
        configurationEntry: NumberOfHitsConfigurationEntry,
    ) => {
        const numberOfHits = numberOfHitsComponentsState.find(
            componentState =>
                componentState?.component === configurationEntry.component,
        )?.numberOfHits;

        if (!numberOfHits) return;

        return `<a href="#${
            configurationEntry.resultListId
        }" class="text-decoration-underline cursor-pointer text-dark">${numberOfHits}&nbsp;${t(
            configurationEntry.translationKey,
        ).replaceAll(" ", "&nbsp;")}</a>`;
    };

    const numberOfHitsEntries = configuration
        .map(toNumberOfHitsEntry)
        .filter(hitStat => hitStat !== undefined);

    if (numberOfHitsEntries.length === 0) return null;

    const joinedNumberOfHits =
        numberOfHitsEntries.length > 1
            ? numberOfHitsEntries.slice(0, -1).join(", ") +
              " " +
              t("search.summary.stats.finalResult", numberOfHitsEntries.at(-1))
            : numberOfHitsEntries.at(0);

    return (
        <p
            className={"mt-2 mb-3"}
            dangerouslySetInnerHTML={{
                __html: t("search.summary.stats", joinedNumberOfHits),
            }}
        ></p>
    );
};

export { NumberOfHitsComponent };
